import { createRouter, createWebHistory } from 'vue-router'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '@/firebase'

import HomePageOne from '../views/home/HomePageOne'
import CreateProduct from '../views/CreateProduct'
import ProductDetails from '../views/ProductDetails'
import Connect from '../views/Connect'
import Collection from '../views/Collection'
import Creators from '../views/Creators'
import AuthorDetails from '../views/AuthorDetails'
import EditProfilePage from '../views/EditProfilePage'
import About from '../views/About'
import Contact from '../views/Contact'
import BlogDetails from '../views/blog/BlogDetails'
import BlogCategoryPosts from '../views/blog/BlogCategoryPosts'
import BlogTagPosts from '../views/blog/BlogTagPosts'
import BlogSingleColumn from '../views/blog/BlogSingleColumn'
import BlogTwoColumn from '../views/blog/BlogTwoColumn'
import BlogThreeColumn from '../views/blog/BlogThreeColumn'
import BlogFourColumn from '../views/blog/BlogFourColumn'
import ExploreOne from '../views/ExploreOne'
import ExploreTwo from '../views/ExploreTwo'
import ExploreThree from '../views/ExploreThree'
import ExploreFour from '../views/ExploreFour'
import ExploreFive from '../views/ExploreFive'
import ExploreSix from '../views/ExploreSix'
import ExploreSeven from '../views/ExploreSeven'
import ExploreEight from '../views/ExploreEight'
import ExploreNine from '../views/ExploreNine'
import ExploreTen from '../views/ExploreTen'
import ExploreEleven from '../views/ExploreEleven'
import ExploreTwelve from '../views/ExploreTwelve'
import ExploreThirteen from '../views/ExploreThirteen'
import ExploreFourteen from '../views/ExploreFourteen'
import UploadVariants from '../views/UploadVariants'
import Activity from '../views/Activity'
import UpcomingProjects from '../views/UpcomingProjects'
import Login from '../views/Login'
import Signup from '../views/Signup'
import ForgetPassword from '../views/ForgetPassword'
import PrivacyPolicy from '../views/PrivacyPolicy'
import Products from '../views/Products'
import Ranking from '../views/Ranking'
import NotFound from '../views/NotFound'
import Support from '../views/Support'
import TermsCondition from '../views/TermsCondition'
import ComingSoon from '../views/ComingSoon'
import Maintenance from '../views/Maintenance'
import Admin from '../views/admin/Admin'

const ADMIN_EMAILS = [
  'admin.tortuga@gmail.com'
]

function getCurrentUser() {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(
      auth,
      (user) => {
        unsubscribe()
        resolve(user)
      },
      reject
    )
  })
}

const routes = [
  {
    path: '/',
    name: 'HomePageOne',
    component: ComingSoon,
    meta: {
      title: 'Sentrys - Digital Agency',
    },
  },
  {
    path: '/create',
    name: 'CreateProduct',
    component: CreateProduct,
    meta: {
      title: 'Create || Sentrys - Digital Agency',
    },
  },
  {
    path: '/product/:id',
    name: 'ProductDetails',
    component: ProductDetails,
    meta: {
      title: 'Product Details || Sentrys - Digital Agency',
    },
  },
  {
    path: '/connect',
    name: 'Connect',
    component: Connect,
    meta: {
      title: 'Connect || Sentrys - Digital Agency',
    },
  },
  {
    path: '/collection',
    name: 'Collection',
    component: Collection,
    meta: {
      title: 'Author || Sentrys - Digital Agency',
    },
  },
  {
    path: '/creator',
    name: 'Creators',
    component: Creators,
    meta: {
      title: 'Collection || Sentrys - Digital Agency',
    },
  },
  {
    path: '/author/:id',
    name: 'AuthorDetails',
    component: AuthorDetails,
    meta: {
      title: 'Author Details || Sentrys - Digital Agency',
    },
  },
  {
    path: '/edit-profile',
    name: 'EditProfilePage',
    component: EditProfilePage,
    meta: {
      title: 'Edit Profile || Sentrys - Digital Agency',
    },
  },
  {
    path: '/about',
    name: 'About',
    component: About,
    meta: {
      title: 'About || Sentrys - Digital Agency',
    },
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
    meta: {
      title: 'Contact || Sentrys - Digital Agency',
    },
  },
  {
    path: '/category/:slug',
    name: 'BlogCategoryPosts',
    component: BlogCategoryPosts,
    meta: {
      title: 'Blog Category List || Sentrys - Digital Agency',
    },
  },
  {
    path: '/tag/:slug',
    name: 'BlogTagPosts',
    component: BlogTagPosts,
    meta: {
      title: 'Blog Tag List || Sentrys - Digital Agency',
    },
  },
  {
    path: '/blog-details/:id',
    name: 'BlogDetails',
    component: BlogDetails,
    meta: {
      title: 'Blog Details || Sentrys - Digital Agency',
    },
  },
  {
    path: '/blog-single-column',
    name: 'BlogSingleColumn',
    component: BlogSingleColumn,
    meta: {
      title: 'Blog Single Column || Sentrys - Digital Agency',
    },
  },
  {
    path: '/blog-col-two',
    name: 'BlogTwoColumn',
    component: BlogTwoColumn,
    meta: {
      title: 'Blog Two Column || Sentrys - Digital Agency',
    },
  },
  {
    path: '/blog-col-three',
    name: 'BlogThreeColumn',
    component: BlogThreeColumn,
    meta: {
      title: 'Blog Three Column || Sentrys - Digital Agency',
    },
  },
  {
    path: '/blog',
    name: 'BlogFourColumn',
    component: BlogFourColumn,
    meta: {
      title: 'Blog Four Column || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-01',
    name: 'ExploreOne',
    component: ExploreOne,
    meta: {
      title: 'Explore Filter || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-02',
    name: 'ExploreTwo',
    component: ExploreTwo,
    meta: {
      title: 'Explore Isotop || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-03',
    name: 'ExploreThree',
    component: ExploreThree,
    meta: {
      title: 'Explore Carousel || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-04',
    name: 'ExploreFour',
    component: ExploreFour,
    meta: {
      title: 'Explore Simple || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-05',
    name: 'ExploreFive',
    component: ExploreFive,
    meta: {
      title: 'Explore With Place Bid || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-06',
    name: 'ExploreSix',
    component: ExploreSix,
    meta: {
      title: 'Place Bid With Filter || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-07',
    name: 'ExploreSeven',
    component: ExploreSeven,
    meta: {
      title: 'Place Bid With Carousel || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-08',
    name: 'ExploreEight',
    component: ExploreEight,
    meta: {
      title: 'Explore Carousel || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-09',
    name: 'ExploreNine',
    component: ExploreNine,
    meta: {
      title: 'Explore List Style || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-10',
    name: 'ExploreTen',
    component: ExploreTen,
    meta: {
      title: 'Explore List Column Two || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-11',
    name: 'ExploreEleven',
    component: ExploreEleven,
    meta: {
      title: 'Live Explore || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-12',
    name: 'ExploreTwelve',
    component: ExploreTwelve,
    meta: {
      title: 'Live Explore Carousel || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-13',
    name: 'ExploreThirteen',
    component: ExploreThirteen,
    meta: {
      title: 'Live With Place Bid || Sentrys - Digital Agency',
    },
  },
  {
    path: '/explore-14',
    name: 'ExploreFourteen',
    component: ExploreFourteen,
    meta: {
      title: 'Explore Filter Left || Sentrys - Digital Agency',
    },
  },
  {
    path: '/upload-variants',
    name: 'UploadVariants',
    component: UploadVariants,
    meta: {
      title: 'Upload Variants || Sentrys - Digital Agency',
    },
  },
  {
    path: '/activity',
    name: 'Activity',
    component: Activity,
    meta: {
      title: 'Activity || Sentrys - Digital Agency',
    },
  },
  {
    path: '/upcoming-projects',
    name: 'UpcomingProjects',
    component: UpcomingProjects,
    meta: {
      title: 'Upcoming Projects || Sentrys - Digital Agency',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: 'Login || Sentrys - Digital Agency',
      guestOnly: true,
    },
  },
  {
    path: '/sign-up',
    name: 'Signup',
    component: Signup,
    meta: {
      title: 'Signup || Sentrys - Digital Agency',
    },
  },
  {
    path: '/forget',
    name: 'ForgetPassword',
    component: ForgetPassword,
    meta: {
      title: 'Forget Password || Sentrys - Digital Agency',
    },
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: 'Privacy Policy || Sentrys - Digital Agency',
    },
  },
  {
    path: '/product',
    name: 'Products',
    component: Products,
    meta: {
      title: 'Product || Sentrys - Digital Agency',
    },
  },
  {
    path: '/ranking',
    name: 'Ranking',
    component: Ranking,
    meta: {
      title: 'Ranking || Sentrys - Digital Agency',
    },
  },
  {
    path: '/404',
    name: 'NotFound',
    component: NotFound,
    meta: {
      title: '404 || Sentrys - Digital Agency',
    },
  },
  {
    path: '/support',
    name: 'Support',
    component: Support,
    meta: {
      title: 'Ranking || Sentrys - Digital Agency',
    },
  },
  {
    path: '/terms-condition',
    name: 'TermsCondition',
    component: TermsCondition,
    meta: {
      title: 'Terms & Condition || Sentrys - Digital Agency',
    },
  },
  {
    path: '/coming-soon',
    name: 'ComingSoon',
    component: ComingSoon,
    meta: {
      title: 'Coming Soon || Sentrys - Digital Agency',
    },
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
    component: Maintenance,
    meta: {
      title: 'Maintenance || Sentrys - Digital Agency',
    },
  },
{
  path: '/admin',
  component: Admin,
  meta: {
    title: 'Admin Panel || Sentrys - Digital Agency',
    requiresAuth: true,
    requiresAdmin: true,
  },
  children: [
    {
      path: '',
      name: 'AdminDashboard',
      component: () => import('../views/admin/AdminDashboard.vue'),
      meta: {
        title: 'Admin Panel || Sentrys - Digital Agency',
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: 'places',
      name: 'AdminPlaces',
      component: () => import('../views/admin/AdminPlaces/AdminPlaces.vue'),
      meta: {
        title: 'Places || Admin Panel',
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: 'users',
      name: 'AdminUsers',
      component: () => import('../views/admin/AdminUsers/AdminUsers.vue'),
      meta: {
        title: 'Users || Admin Panel',
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: 'connections',
      name: 'ConnectionsUsers',
      component: () => import('../views/admin/ConnectionsUsers/ConnectionsUsers.vue'),
      meta: {
        title: 'Connections || Admin Panel',
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
    {
      path: 'sessions',
      name: 'Sessions',
      component: () => import('../views/admin/Sessions/Sessions.vue'),
      meta: {
        title: 'Sessions || Admin Panel',
        requiresAuth: true,
        requiresAdmin: true,
      },
    },
  ],
},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})


router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || 'Sentrys - Digital Agency'
  window.scrollTo(0, 0)

  const user = await getCurrentUser()

  if (to.meta.requiresAuth && !user) {
    next('/login')
    return
  }

  if (to.meta.guestOnly && user) {
    next('/admin')
    return
  }

  if (to.meta.requiresAdmin) {
    const email = (user?.email || '').toLowerCase()

    if (!user || !ADMIN_EMAILS.includes(email)) {
      next('/login')
      return
    }
  }

  next()
})

export default router